export const VALUES = [
  { name: "Whānau", desc: "We welcome people of all ages and backgrounds and treat everyone like family." },
  { name: "Inclusiveness", desc: "We remove barriers so anyone — regardless of ability, location or background — can participate." },
  { name: "Non-judgemental", desc: "We create a safe, supportive and encouraging environment to learn and enjoy the game without pressure." },
  { name: "Community", desc: "We focus on bringing rural and regional communities together through the sport." },
  { name: "Opportunity", desc: "We provide clear pathways for fun, learning, development and competition." },
];

export const BENEFITS = [
  "A genuine sense of belonging in a supportive, non-judgemental community",
  "Access to social nights, come-and-try sessions and school holiday programmes",
  "Coaching and development pathways from beginner to representative level",
  "Fair and consistent opportunities to compete across the region",
  "A collective voice within Table Tennis New Zealand",
];

export const REGIONS = ["Taranaki", "Bay of Plenty", "Taupō", "Central Plateau"];

export const DEFAULTS = {
  site_name: "Te Manawa Table Tennis Association",
  tagline: "The Heart of the North Island",
  logo_image: "",
  hero_title: "Te Manawa Table Tennis",
  hero_subtitle: "The Heart of the North Island",
  hero_image: "",
  welcome_heading: "A new home for table tennis in the central North Island",
  welcome_body: "",
  highlight_community_title: "Community",
  highlight_community_body: "",
  highlight_participation_title: "Participation",
  highlight_participation_body: "",
  highlight_pathways_title: "Pathways",
  highlight_pathways_body: "",
  region_heading: "Serving the heart of the North Island",
  region_body: "",
  about_hero_heading: "About Te Manawa",
  about_hero_sub: "",
  contact_person: "Tony Smith",
  contact_email: "shonatony.smith@gmail.com",
  contact_phone: "+64 21 2124842",
  contact_postal: "PO Box 12230, Chartwell, Hamilton 3248",
  contact_note: "",
};
